export default function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
            联系我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            联系与反馈
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            有任何问题或建议，欢迎联系我们
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center p-5 bg-background-50 rounded-xl border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">邮箱联系</h3>
                <p className="text-xs text-foreground-500">feedback@beiwo.com</p>
              </div>
              <div className="text-center p-5 bg-background-50 rounded-xl border border-background-200/60 cursor-pointer hover:border-accent-200 transition-colors">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">微信公众号</h3>
                <p className="text-xs text-foreground-500">搜索「被窝影院」</p>
              </div>
              <div className="text-center p-5 bg-background-50 rounded-xl border border-background-200/60 cursor-pointer hover:border-secondary-300 transition-colors">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-telegram-line text-xl text-secondary-700"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">Telegram</h3>
                <p className="text-xs text-foreground-500">@beiwo_tv</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}